import React, { useEffect, useState } from 'react';
import mapboxgl from 'mapbox-gl';
import axios from 'axios';
import Papa from 'papaparse';
import Navbar from '../Navbar/Navbar.js';
import './Mappage.css';
import 'mapbox-gl/dist/mapbox-gl.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { fetchShipDetails, setIsModalOpen } from '../Vessel/VesselProfile.js'
mapboxgl.accessToken = 'pk.eyJ1IjoibWljaGFlbC1qYWNvdCIsImEiOiJjbThkY2lmOGQwbWZoMmpvZ2Z1M2xsYTRsIn0.WZPUkFIAIenQhNTTPbVVuQ';

const MapPage = ({ handleLogout,isLoggedIn }) => {
  const [map, setMap] = useState(null);
  const [shipPositions, setShipPositions] = useState([]);
  const [selectedShipInfo, setSelectedShipInfo] = useState(null);
  const [selectedShipType, setSelectedShipType] = useState(null); 
  const [searchQuery, setSearchQuery] = useState(''); 
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [productTypes, setProductTypes] = useState([]);
  const [initialized, setInitialized] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState('');
  const [filteredShipPositions, setFilteredShipPositions] = useState([]);
  const location = useLocation();
  const navigate = useNavigate(); 
  const queryParams = new URLSearchParams(location.search);

  const parseCSVForProductTypes = (csvData) => {
    const parsed = Papa.parse(csvData, { header: true });
    
    const types = new Set(parsed.data.map(entry => entry.Product));
    const productTypes = Array.from(types);
    
    return productTypes;
};



  const handleGlobeView = () => {
    navigate('/globe');
  };
  const toggleDarkMode = () => {
    const darkModeStyle = 'mapbox://styles/mapbox/dark-v10';
    const defaultStyle = 'mapbox://styles/mapbox/streets-v11';

    setIsDarkMode(!isDarkMode); // Toggle dark mode state
  map.setStyle(isDarkMode ? defaultStyle : darkModeStyle);

  map.once('style.load', () => {
    addShipLayers();
    
  });
};

  useEffect(() => {
    let popup;
    if (map) {
      const popup = new mapboxgl.Popup({
        closeButton: true,
        closeOnClick: false,
      });
  
      map.on('click', 'ships', (e) => {
        const features = map.queryRenderedFeatures(e.point, { layers: ['ships'] });
        
        if (!features.length) {
          return;
        }
        
        const position = features[0].properties;
        const SHIPNAME = position.SHIPNAME;
        
        // Fetch additional ship info using SHIPNAME here from the same API
        fetchAdditionalShipInfo(SHIPNAME, (shipInfo) => {
          // Create an HTML element for the popup content
          const popupContent = document.createElement('div');
          popupContent.innerHTML = `
            <h3>${SHIPNAME}</h3>
            <p>IMO: ${shipInfo?.IMO}</p>
            <p>Temperature: ${shipInfo?.TEMPERATURE}°C</p>
            <p>Salinity: ${shipInfo?.SALINITY}</p>
            <p>Last Port: ${shipInfo?.LAST_PORT}</p>
            <div class="button-container">
              <button class="popup-button" id="vessel-profile">Vessel Profile</button>
              <button class="popup-button" id="past-track">Past Track</button>
            </div>
          `;
  
          const buttonContainer = popupContent.querySelector('.button-container');
          buttonContainer.style.display = 'flex'; // Use flexbox
          buttonContainer.style.justifyContent = 'space-between'; // Align buttons horizontally
          buttonContainer.style.marginTop = '10px'; // Add margin to separate from the content
  
          // Style the buttons
          const buttons = popupContent.querySelectorAll('.popup-button');
          buttons.forEach(button => {
            button.style.backgroundColor = 'blue'; // Set background color
            button.style.color = 'white'; // Set text color
            button.style.padding = '5px 10px'; // Set padding
            button.style.border = 'none'; // Remove border
            button.style.borderRadius = '5px'; // Add border radius
            button.style.cursor = 'pointer'; // Change cursor on hover
            button.style.flex = '0.85'; // Make buttons flexible to adjust size
            button.style.marginRight = '5px'; // Add margin between buttons
            button.style.fontSize = '12px';
          });
  
          popup.setLngLat(features[0].geometry.coordinates)
            .setDOMContent(popupContent)
            .addTo(map);
  
          // Add event listeners for the buttons
          const vesselProfileButton = document.getElementById('vessel-profile');
          const pastTrackButton = document.getElementById('past-track');
          
          vesselProfileButton.addEventListener('click', () => {
            // Handle the Vessel Profile button click event
            const vesselIMO = shipInfo?.IMO; // Assuming you have the IMO in shipInfo
            if (vesselIMO) {
              // Open the API page with the vessel IMO in a new tab
              window.open(`https://backend-nu-two.vercel.app/getBFMImage/${vesselIMO}`, '_blank');
            } else {
              console.error('IMO not available');
              // Optionally, provide feedback to the user if IMO is not available
            }
            console.log('Vessel Profile button clicked');
          });
          
  
          pastTrackButton.addEventListener('click', () => {
            // Handle the Past Track button click event
            // Construct the URL with the vessel IMO and redirectt
            const vesselIMO = shipInfo?.IMO; // Assuming you have the IMO in shipInfo
            if (vesselIMO) {
                // Redirect to the API page with the vessel IMO
                window.location.href = `https://backend-nu-two.vercel.app/getVesselRoute/${vesselIMO}`;
            } else {
                console.error('IMO not available');
                // Optionally, provide feedback to the user if IMO is not available
            }
        });
        
        });
      });

      map.on('click', () => {
        if (popup) {
          popup.remove(); // This will close the popup
        }
      });
  
      map.on('mouseenter', 'ships', () => {
        map.getCanvas().style.cursor = 'pointer';
      });
  
      map.on('mouseleave', 'ships', () => {
        map.getCanvas().style.cursor = '';
      });
    }return () => {
      if (popup) {
        popup.remove();
      }
    };
  }, [map]);
  
  // Function to fetch additional ship info from the same API
  const fetchAdditionalShipInfo = (shipName, callback) => {
    // Make a request to the same API to fetch additional ship info based on the shipName
    axios.get(`https://backend-nu-two.vercel.app/getShipInfo/${shipName}`)
      .then(response => {
        const shipInfo = response.data;
        
        setSelectedShipInfo(shipInfo);
        callback(shipInfo); // Call the callback function with shipInfo
      })
      .catch(error => {
        console.error('Error fetching ship info:', error);
        setSelectedShipInfo(null); // Clear the selected ship info in case of an error
      });
  };

  const parseCSV = csvData => {
    const parsed = Papa.parse(csvData, { header: true });
    
    const latestPositions = new Map();

    parsed.data.forEach(entry => {
      const shipName = entry.SHIPNAME;

      if (!latestPositions.has(shipName) || entry.TIMESTAMP > latestPositions.get(shipName).TIMESTAMP) {
        latestPositions.set(shipName, {
          shipName,
          latitude: parseFloat(entry.LAT),
          longitude: parseFloat(entry.LON),
          AIS_TYPE_SUMMARY: entry.AIS_TYPE_SUMMARY,
          temperature: parseFloat(entry.TEMPERATURE), // Assuming temperature is a CSV column
          salinity: parseFloat(entry.SALINITY), // Assuming salinity is a CSV column
          lastPort: entry.LAST_PORT, // Assuming last port is a CSV column
          product: entry.Product,
        });
      }
    });

    return Array.from(latestPositions.values());
  };

  const handleLegendItemClick = (type) => {
    setSelectedShipType(type); // Update state to reflect selected ship type for potential other uses
  
    // Filter the ship positions based on the selected type and update the map
    const filteredShips = shipPositions.filter(ship => ship.properties.AIS_TYPE_SUMMARY === type);
    updateMapWithFilteredShips(filteredShips);
  };
  
  const updateMapWithFilteredShips = (filteredShips) => {
    let geojsonData;

    if (filteredShips.length > 0) {
        geojsonData = {
            type: 'FeatureCollection',
            features: filteredShips.map(ship => ({
                type: 'Feature',
                geometry: {
                    type: 'Point',
                    coordinates: [parseFloat(ship.geometry.coordinates[0]), parseFloat(ship.geometry.coordinates[1])]
                },
                properties: ship.properties
            }))
        };
    } else {
        // If no ships match the selected product, display all ships on the map
        geojsonData = {
            type: 'FeatureCollection',
            features: shipPositions.map(ship => ({
                type: 'Feature',
                geometry: {
                    type: 'Point',
                    coordinates: [parseFloat(ship.geometry.coordinates[0]), parseFloat(ship.geometry.coordinates[1])]
                },
                properties: ship.properties
            }))
        };
    }

    if (map && map.getSource('ships')) {
        // Update the data of the 'ships' source to only include the filtered ships or all ships if no filter applied
        map.getSource('ships').setData(geojsonData);
    }
};
const handleKeyPress = (event) => {
  if (event.key === 'Enter') {
    handleSearch(); // Call the handleSearch function when Enter key is pressed
  }
};
const handleSearch = () => {
  if (!searchQuery) {
    alert('Please enter a search query.');
    return;
  }

  // Filter based on ship name within the properties of each GeoJSON feature
  const filteredShips = shipPositions.filter(ship => 
    ship.properties.SHIPNAME && ship.properties.SHIPNAME.toLowerCase().includes(searchQuery.toLowerCase())
  );
  

  if (filteredShips.length === 0) {
    alert('No ships found with that name.');
    return;
  }

  // Convert filtered ships to GeoJSON before updating the map
  const filteredGeoJSONFeatures = filteredShips.map(ship => ({
    type: 'Feature',
    properties: ship, // Place the entire ship object in properties
    geometry: {
      type: 'Point',
      coordinates: [parseFloat(ship.LON), parseFloat(ship.LAT)]
    }
  }));

  setIsSearchActive(false);
  updateMap(filteredShips); // Pass GeoJSON features to updateMap
};
  
  const resetFilters = () => {
    setSearchQuery('');
    setSelectedShipType(null);
    setIsSearchActive(false);
    setSelectedProduct('');
    updateMap(shipPositions);
    
  };
  
  // Transform data to GeoJSON features
  const updateMap = (data) => {
    

    const features = data.map(ship => {
      return {
        ...ship,
        geometry: {
          ...ship.geometry,
          coordinates: [parseFloat(ship.geometry.coordinates[0]), parseFloat(ship.geometry.coordinates[1])]
        },
        properties: {
          ...ship.properties,
        }
      };
    });
  
    
  
    if (map) {
      // Check if the 'ships' source exists before updating
      if (!map.getSource('ships')) {
        map.addSource('ships', {
          type: 'geojson',
          data: {
            type: 'FeatureCollection',
            features: features,
          },
        });
      } else {
        map.getSource('ships').setData({
          type: 'FeatureCollection',
          features: features,
        });
      }
    } else {
      console.error("Map not initialized.");
    }
  };
  useEffect(() => {
    const initializeMap = () => {
      const newMap = new mapboxgl.Map({
        container: 'map',
        style: 'mapbox://styles/mapbox/streets-v11',
        center: [0, 0],
        zoom: 2,
      });
  
      newMap.on('load', () => {
        setMap(newMap);
        fetchShipPositions(); // Fetch ship positions once the map is loaded
        updateMap(shipPositions);
      });
  
      newMap.once('style.load', () => {
        addShipLayers();
      });
    };
  
    initializeMap();
  }, []);

// Function to fetch ship positions from the CSV file
const fetchShipPositions = (selectedProduct) => {
  axios
    .get('https://backend-nu-two.vercel.app/VCSSMaster1.csv')
    .then((response) => {
      const shipData = response.data;
      
      

      // Extract unique product types
      const productTypes = Array.from(new Set(shipData.map(ship => ship.Product)));
      console.log('Product Types:', productTypes); // Debugging statement

      setShipPositions(
        shipData.map((ship) => ({
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [parseFloat(ship.LON), parseFloat(ship.LAT)],
          },
          properties: {
            SHIPNAME: ship.SHIPNAME,
            AIS_TYPE_SUMMARY: ship.AIS_TYPE_SUMMARY,
            Product: ship.Product,
            // Add other properties if needed
          },
        }))
      );
      setProductTypes(productTypes);

      // Check if there's a selected ship type or search query
      if (selectedProduct) {
        // Filter ship data based on selected product type
        const filteredShipData = shipData.filter(ship => ship.Product === selectedProduct);
        updateMap(filteredShipData); // Update the map with filtered ship positions
      } else if (searchQuery) {
        handleSearch();
      } else {
        updateMap(shipData); // Update the map with all positions
      }
    })
    .catch((error) => {
      console.error('Error fetching ship positions:', error);
    });
};

const addShipLayers = () => {
  if (!map) return;

  if (!map.getSource('ships')) {
    map.addSource('ships', {
      type: 'geojson',
      data: {
        type: 'FeatureCollection',
        features: shipPositions,
      },
    });
  }

  if (!map.getLayer('ships')) {
    map.addLayer({
      id: 'ships',
      type: 'circle',
      source: 'ships',
      paint: {
        'circle-radius': 8,
        'circle-color': [
          'match',
          ['get', 'AIS_TYPE_SUMMARY'],
          'Tanker', '#FF0000', // Red for Tankers
          'Cargo', '#00FF00', // Green for Cargo
          'Passenger', '#0000FF', // Blue for Passenger
          'Special Craft', '#FFA500', // Orange for Special Craft
          'Fishing', '#FFFF00', // Yellow for Fishing
          'Other', '#808080', // Gray for Other
          /* Default */ '#000000' // Default color
        ],
      },
    });
  }

  if (!map.getLayer('ship-heatmap')) {
    map.addLayer({
      id: 'ship-heatmap',
      type: 'heatmap',
      source: 'ships',
      maxzoom: 9,
      paint: {
        'heatmap-weight': 0.5,
        'heatmap-intensity': {
          stops: [[0, 1], [9, 3]],
        },
        'heatmap-color': [
          'interpolate',
          ['linear'],
          ['heatmap-density'],
          0, 'rgba(33,102,172,0)',
          0.2, 'rgb(103,169,207)',
          0.4, 'rgb(209,229,240)',
          0.6, 'rgb(253,219,199)',
          0.8, 'rgb(239,138,98)',
          1, 'rgb(178,24,43)',
        ],
        'heatmap-radius': {
          stops: [[0, 2], [9, 20]],
        },
      },
    });
  }
};

const goToMapPage = () => {
  navigate('/port'); // Redirect to the MapPage
};
const handleProductFilterChange = (selectedProduct) => {
  console.log('Selected Product:', selectedProduct); // Debugging

  setSelectedProduct(selectedProduct); // Set selectedProduct state to the selected option
  const filteredShips = shipPositions.filter(ship => {
    console.log('Ship Product:', ship.properties.Product); // Debugging
    return ship.properties.Product === selectedProduct;
  });

  

  updateMapWithFilteredShips(filteredShips);
};

  useEffect(() => {
    if (map) {
      fetchShipPositions();
      map.on('moveend', () => {
       
        if (!isSearchActive) {
          fetchShipPositions();
        }
      });
    }

  
    // Return a cleanup function
    return () => {
      if (map) {
        map.off('moveend', fetchShipPositions);
      }
    };
  }, [map, isSearchActive, selectedShipType]); 

  useEffect(() => {
    if (searchQuery === '') {
      setIsSearchActive(false);
      setFilteredShipPositions([]);
      fetchShipPositions(); 
    }
  }, [searchQuery]);

  useEffect(() => {
    if (map) {
      map.addSource('ships', {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: [],
        },
      });
      
      map.addLayer({
        id: 'ships',
        type: 'circle',
        source: 'ships',
        paint: {
          'circle-radius': 8,
          'circle-color': [
            'match',
            ['get', 'AIS_TYPE_SUMMARY'],
            'Tanker', '#FF0000', // Red for Tankers
            'Cargo', '#00FF00', // Green for Cargo
            'Passenger', '#0000FF', // Blue for Passenger
            'Special Craft', '#FFA500', // Orange for Special Craft
            'Fishing', '#FFFF00', // Yellow for Fishing
            'Other', '#808080', // Gray for Other
            /* Default */ '#000000' // Default color
          ],
        },
      });
      map.addLayer({
        id: 'ship-heatmap',
        type: 'heatmap',
        source: 'ships',
        maxzoom: 9,
        paint: {
          // Increase the heatmap weight based on frequency and property magnitude
          'heatmap-weight': [
            'interpolate',
            ['linear'],
            ['get', 'magnitude'], // Replace 'magnitude' with a relevant property from your data
            0,
            0,
            6,
            1
          ],
          // Increase the heatmap color weight weight by zoom level
          // heatmap-intensity is a multiplier on top of heatmap-weight
          'heatmap-intensity': [
            'interpolate',
            ['linear'],
            ['zoom'],
            0,
            1,
            9,
            3
          ],
          // Color ramp for heatmap. 
          'heatmap-color': [
            'interpolate',
            ['linear'],
            ['heatmap-density'],
            0,
            'rgba(33,102,172,0)',
            0.2,
            'rgb(103,169,207)',
            0.4,
            'rgb(209,229,240)',
            0.6,
            'rgb(253,219,199)',
            0.8,
            'rgb(239,138,98)',
            1,
            'rgb(178,24,43)'
          ],
          // Adjust the heatmap radius by zoom level
          'heatmap-radius': [
            'interpolate',
            ['linear'],
            ['zoom'],
            0,
            2,
            9,
            20
          ],
        }
      });

      fetchShipPositions();
      updateMap(shipPositions);
    }
  }, [map]);
  

  return (
    <div>
    <Navbar isLoggedIn={isLoggedIn} onLogout={handleLogout} />
    <div style={{ height: 'calc(100vh - 5px)', position: 'relative' }}>
    <div id="map" style={{ width: '100%', height: '100%' }} />
    <div style={{
      position: 'absolute',
      bottom: '0',
      left: '0',
      right: '0',
      background: 'rgba(255, 255, 255, 0.7)',
      padding: '5px',
      display: 'flex',
      justifyContent: 'space-between', // Align children to the sides
      alignItems: 'center', // Center children vertically
      zIndex: 10
    }}>
      <div>
      <h3 style={{ fontWeight: 'bold', margin: '0' }}>Ship Type Legend</h3> {/* Title */}
      <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap', justifyContent: 'center', marginTop: '10px' }}>
        <ul style={{ listStyle: 'none', padding: 0, display: 'flex', gap: '10px', alignItems: 'center' }}> 
        <li style={{ fontWeight: 'bold', marginBottom: '5px', cursor: 'pointer' }}
          onClick={() => handleLegendItemClick('Tanker')}>
         <span style={{ display: 'inline-block', width: '20px', height: '20px', backgroundColor: '#FF0000', marginRight: '10px' }}></span>
           Tanker
        </li>
          <li style={{ fontWeight: 'bold', marginBottom: '5px', cursor:'pointer' }}
           onClick={() => handleLegendItemClick('Cargo')}>
            <span style={{ display: 'inline-block', width: '20px', height: '20px', backgroundColor: '#00FF00', marginRight: '10px' }}></span>
            Cargo
          </li>
          <li style={{ fontWeight: 'bold', marginBottom: '5px', cursor:'pointer' }}
          onClick={() => handleLegendItemClick('Passenger')}>
            <span style={{ display: 'inline-block', width: '20px', height: '20px', backgroundColor: '#0000FF', marginRight: '10px' }}></span>
            Passenger
          </li>
          <li style={{ fontWeight: 'bold', marginBottom: '5px', cursor:'pointer' }}
          onClick={() => handleLegendItemClick('Special Craft')}>
            <span style={{ display: 'inline-block', width: '20px', height: '20px', backgroundColor: '#FFA500', marginRight: '10px' }}></span>
            Special Craft
          </li>
          <li style={{ fontWeight: 'bold', marginBottom: '5px', cursor:'pointer' }}
          onClick={() => handleLegendItemClick('Fishing')}>
            <span style={{ display: 'inline-block', width: '20px', height: '20px', backgroundColor: '#FFFF00', marginRight: '10px' }}></span>
            Fishing
          </li>
          <li style={{ fontWeight: 'bold', marginBottom: '5px', cursor:'pointer', marginRight: '2px' }}
          onClick={() => handleLegendItemClick('Other')}>
            <span style={{ display: 'inline-block', width: '20px', height: '20px', backgroundColor: '#808080', marginRight: '10px' }}></span>
            Other
          </li>
        </ul>
        </div>
        </div>
        <button onClick={handleGlobeView} className="pushable" style={{marginRight: '10px', position: 'relative', border: 'none', cursor: 'pointer', background: 'transparent' }}>
        <span className="shadow"></span>
        <span className="edge"></span>
        <span className="front" style={{  backgroundColor: '#007BFF', color: 'white', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '1.5px', fontSize: '1rem' }}>
          Globe 
        </span>
      </button>
        <div className="search-box" style={{ display: 'absolute', justifyContent: 'flex-end', alignItems: 'center', marginBottom: '10px', marginRight: '10px' }}>
        <select value={selectedProduct} onChange={(e) => handleProductFilterChange(e.target.value)} style={{ padding: '5px', marginRight: '5px', width: '200px' }}>
  <option value="">All Products</option>
  {productTypes.map((type, index) => (
    <option key={index} value={type}>{type}</option>
  ))}
</select>
    <input
      type="text"
      placeholder="Search ships..."
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
      onKeyDown={handleKeyPress}
      style={{ padding: '5px', marginRight: '13px', width: '200px' }}
    />
    <button onClick={handleSearch} className="pushable" style={{ marginRight: '13px' }}>
  <span className="shadow"></span>
  <span className="edge"></span>
  <span className="front">Search</span>
</button>

<button onClick={resetFilters} className="pushable" >
  <span className="shadow"></span>
  <span className="edge"></span>
  <span className="front">Reset</span>
</button>

<button onClick={toggleDarkMode} className="pushable" style={{ marginLeft: '13px' }}>
  <span className="shadow"></span>
  <span className="edge"></span>
  <span className="front">Dark Mode</span>
</button>
 {/* Button to redirect to MapPage */}
 <button onClick={goToMapPage} className="pushable" style={{ marginLeft: '20px', backgroundColor: '#007bff', color: '#fff', padding: '7px 14px', border: 'none', borderRadius: '4.5px', fontSize: '15px', position: 'relative' }}>
  <span className="front">
    Port Cleanings
    <span style={{ fontSize: '0.7em', color: 'yellow', marginLeft: '5px' }}>(Beta)</span>
  </span>
</button>

  </div>
      </div>
    </div>
    </div>
  );
};

export default MapPage;
